"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImage = exports.isPersonalizedImageSource = exports.ImageSchema = void 0;
const zod_1 = require("zod");
const iso_date_string_types_1 = require("./iso_date_string_types");
const PersonalizedImageSourceSchema = zod_1.z.union([
    zod_1.z.literal("camera"),
    zod_1.z.literal("library"),
    zod_1.z.literal("drawing"),
]);
exports.ImageSchema = zod_1.z.object({
    deleted_at: iso_date_string_types_1.IsoDateStringSchema.optional(),
    hash: zod_1.z.string().optional(),
    height: zod_1.z.number().optional(),
    id: zod_1.z.string().optional(),
    private: zod_1.z.boolean().optional(),
    source: PersonalizedImageSourceSchema.optional(),
    thumbnailUrl: zod_1.z.string().optional(),
    url: zod_1.z.string(),
    width: zod_1.z.number().optional(),
    x_offset: zod_1.z.number().optional(),
    y_offset: zod_1.z.number().optional(),
});
const isPersonalizedImageSource = (source) => PersonalizedImageSourceSchema.safeParse(source).success;
exports.isPersonalizedImageSource = isPersonalizedImageSource;
const isImage = (x) => exports.ImageSchema.safeParse(x).success;
exports.isImage = isImage;
//# sourceMappingURL=image_association_types.js.map